import styled from "@emotion/styled";
export const StyledParagraphWithLogosComponent = styled.div`
  .paragraph-wrapper {
    margin-bottom: 24px;
  }
`;
